import React from 'react'
import { FormattedMessage } from 'react-intl'

/* eslint-disable */
export const headCells = [
  {
    id: 'name',
    label: <FormattedMessage id="label.Name" />,
    minWidth: '206px',
    align: 'left',
  },
  {
    id: 'email',
    label: <FormattedMessage id="label.email" />,
    minWidth: '250px',
    align: 'left',
  },
  {
    id: 'role',
    label: <FormattedMessage id="label.role" />,
    minWidth: '123px',
    align: 'left',
  },
  {
    id: 'availability',
    label: <FormattedMessage id="heading.Manage_Availability" />,
    minWidth: '150px',
    align: 'left',
  },
  {
    id: 'status',
    label: 'License Status',
    minWidth: '140px',
    align: 'left',
  },
];

export const headCellsNoLicenseOrAvailability = [
  {
    id: 'name',
    label: <FormattedMessage id="label.Name" />,
    minWidth: '180px',
    align: 'left',
  },
  {
    id: 'email',
    label: <FormattedMessage id="label.email" />,
    minWidth: '200px',
    align: 'left',
  },
  {
    id: 'isAdmin',
    label: <FormattedMessage id="table.column.header.isAdmin" />,
    minWidth: '150px',
    align: 'center',
  },
  {
    id: 'isProvider',
    label: <FormattedMessage id="table.column.header.isProvider" />,
    minWidth: '158px',
    align: 'center',
  },
];

export const memberFilters = {
  status: [
    {
      id: 'status1',
      name: 'Scheduled',
      type: 'status',
      code: 1,
    },
    {
      id: 'status2',
      name: 'Completed',
      type: 'status',
      code: 4,
    },
    {
      id: 'status3',
      name: 'Member Missed',
      type: 'status',
      code: 8,
    },
    {
      id: 'status4',
      name: 'Coach Missed',
      type: 'status',
      code: 10,
    },
    {
      id: 'status5',
      name: 'Cancelled',
      type: 'status',
      code: 5,
    },
    {
      id: 'status6',
      name: 'In Progress',
      type: 'status',
      code: 3,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/NewTeamMembers/data/mockData.js